import { render, staticRenderFns } from "./createFreeAccount.vue?vue&type=template&id=2335ad72&scoped=true"
import script from "./createFreeAccount.vue?vue&type=script&lang=js"
export * from "./createFreeAccount.vue?vue&type=script&lang=js"
import style0 from "./createFreeAccount.vue?vue&type=style&index=0&id=2335ad72&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2335ad72",
  null
  
)

export default component.exports